/**
 * @file main
 * @author fuqiang15(fuqiang15@baidu.com)
 */
import 'es6-promise/auto';
import Vue from 'vue';
import App from './App';
import Router from 'vue-router';
import LoginView from './views/Login';
import RegisterView from './views/Register';

// 当 cookie 过期或者注销后会有一个类似下面的一个 redirectUrl
// brandplus.baidu.com/?fromu=brandplus.baidu.com#/client/index.html/card/list
// 若是这种情况，需要默认渲染 LoginView
const router = new Router({
    routes: [
        {
            path: '/',
            component: LoginView
        },
        {
            path: '/register',
            component: RegisterView
        },
        {
            path: '*',
            component: LoginView
        }
    ]
});

Vue.use(Router);
new Vue({
    el: '#app',
    render(createElement) {
        return createElement('app');
    },
    router,
    components: {
        App
    }
});
